import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../../services/common';

@Component({
  selector: 'app-address-detail',
  templateUrl: './address-detail.component.html',
  styleUrl: './address-detail.component.scss'
})
export class AddressDetailComponent implements OnInit {
  @Input() adressMetaData: any;
  @Output() closeModal = new EventEmitter<any>();
  @Input() context: any;
  addressForm!: FormGroup;
  states: any[] = [];
  districts: any[] = [];
  cityList: any[] = []
  showAdressModal: boolean = false;
  Submitted = false;
  addressDetailData: any;
  isVisible: boolean = false;
  fullAddress: any = null;
  selectedCity: any;
  selectedState: any;
  selectedDistrict: any;
  constructor(private formBuilder: FormBuilder, private commonService: CommonService
  ) {

  }

  ngOnInit(): void {
    this.getStates()
    this.initiateAddressForm();
    this.selectCityAndState(false);

  }

  private selectCityAndState(stateChangedfromUI: boolean) {
    if (this.states?.length && !stateChangedfromUI) {
      this.defaultCurrentState();
    }

    if (this.cityList?.length && !stateChangedfromUI) {
      this.defaultCurrentCity();
    }
  }

  /**
   * data is firstly set here
   */
  ngOnChanges(changes: SimpleChanges) {
    if ((changes as any).adressMetaData && !(changes as any).adressMetaData.firstChange) {
      if (!this.states || !this.states.length) {
        this.getStates();
      } else {
        setTimeout(() => {
          this.getCities(false);
        });
      }
      this.setData((changes as any).adressMetaData);
    } else {
      setTimeout(() => {
        this.getCities(false);
      });
    }
  }

  /**
   * Set address detail in form
   */
  setData(adressMetaData: SimpleChange) {
    this.fullAddress = adressMetaData?.currentValue?.address?.address1;
    this.addressForm?.patchValue({
      localityAdress: adressMetaData?.currentValue?.address?.address1,
      city: adressMetaData?.currentValue?.address?.city,
      state: adressMetaData?.currentValue?.address?.state,
      pincode: adressMetaData?.currentValue?.address?.pinCode
    })
  }

  /**
   * set default current state
   */
  defaultCurrentState() {
    if (this.adressMetaData && this.adressMetaData?.address?.state) {
      this.selectedState = undefined;
      this.selectedState = this.states?.find(i => i.id === this.adressMetaData.address.state.id);
    } else {
      this.selectedState = null;
    }
  }

  /**
   * set default current city
   */
  defaultCurrentCity() {
    if (this.adressMetaData && this.adressMetaData?.address?.city) {
      this.selectedCity = undefined;
      this.selectedCity = this.cityList.find(city => city.id === this.adressMetaData?.address?.city?.id);
    } else {
      this.selectedCity = null;
    }
  }

  //initiating the address form
  initiateAddressForm() {
    this.addressForm = this.formBuilder.group({
      localityAdress: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      district: [''],
      pincode: ['', [Validators.required]],
      village: [''],
      tehsil: ['']
    });
  };




  /**
   * returns the form control after
   */
  get f(): { [key: string]: AbstractControl } {
    return this.addressForm.controls;
  }

  /**
   * getting the state data on behalf of India's country id
   */
  getStates() {
    this.commonService.getLocations("state", "country", 102).subscribe((res: any) => {
      this.states = res?.result;
      this.defaultCurrentState();
    })
  }

  /**
   * getting City Data on behlf of District Id
   */
  getCities(stateChangedfromUI: boolean) {
    if (this.selectedState?.id > 0) {
      this.commonService.getLocations("city", "district", this.selectedDistrict?.id).subscribe((res: any) => {
        this.cityList = res?.result;
        this.addressForm.controls['city'].reset();
        this.selectCityAndState(stateChangedfromUI);
        // this.defaultCurrentCity();
      })
    }
    else {
      this.districts = [];
    }
  }


  /**
   * getting District Data on behlf of stateId
   */
  getDistrict(stateChangedfromUI: boolean) {
    if (this.selectedState?.id) {
      this.commonService.getLocations("district", "state", this.selectedState?.id).subscribe((res: any) => {
        this.districts = res?.result;
        this.addressForm.controls['district'].reset();

        this.selectCityAndState(stateChangedfromUI);
        // this.defaultCurrentCity();
      })
    }
    else {
      this.cityList = [];
    }
  }

  /**
   * method used to update user address
   */
  onSubmit() {
    this.Submitted = true;
    if (this.addressForm?.invalid) {
      return;
    }
    let address = ((this.addressForm?.value?.localityAdress) ? this.addressForm?.value?.localityAdress : '') + (this.selectedCity?.name ? (' ' + ',' + this.selectedCity?.name + ',' + ' ') : '') + ((this.selectedState?.name) ? (this.selectedState?.name) : '') + ((this.addressForm?.value?.pincode) ? (' ' + '-' + this.addressForm?.value?.pincode) : '');

    this.Submitted = false;

    this.closeModal.emit({
      'addressType': this.adressMetaData?.address?.addressType,
      'address': {
        "address1": this.addressForm?.value?.localityAdress,
        "city": this.selectedCity,
        "state": this.selectedState,
        "village": '',
        "pinCode": this.addressForm?.value?.pincode ? this.addressForm?.value?.pincode : ''
      },
      "fullAddress": address
    });

    // this.addressForm.reset();
  }

  /**
   * method used to close the modal
   */
  close() {
    this.Submitted = false;
    this.closeModal?.emit({
      "showAddUpdateModal": false
    });
  }

  /**
   * on mouseleaving from state and city so that full address is generated and displayed
   */
  onMouseLeavefromLastInput() {
    let filteredState = this.states.find(state => state?.id === this.addressForm?.value?.state?.id);
    let city = this.cityList.find((city: any) => city.id == this.addressForm?.value?.city?.id);
    let address = this.addressForm?.value?.localityAdress + ',' + ' ' + city?.name + ',' + ' ' + filteredState?.name + ' ' + '-' + this.addressForm?.value?.pincode;
    this.fullAddress = address;
    this.adressMetaData.fullAdress = address;
  }
}
